module.exports = __webpack_public_path__ + "media/advantage/promoBooks-1e3feb36.png";